"use client";

import { Box, BoxProps } from "@mui/material";
import { FC } from "react";

export interface VariantProps {
  iconSrc?: string; // For SVG files
  iconName?: string; // For iconify icons (future support)
  size?: number | string;
  cssProps?: BoxProps["sx"];
}

const ServiceIcon: FC<VariantProps> = ({ iconSrc, iconName, size = 64, cssProps }) => {
  // Default styles for service icons
  const defaultStyles: BoxProps["sx"] = {
    width: size,
    height: size,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    ...cssProps,
  };

  // If using SVG file
  if (iconSrc) {
    return (
      <Box sx={defaultStyles}>
        <Box
          component="img"
          src={iconSrc}
          alt="Service icon"
          loading="lazy"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain", // Maintain aspect ratio
            filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1))",
            transition: "transform 0.3s ease, filter 0.3s ease",
            "&:hover": {
              transform: "scale(1.1)",
              filter: "drop-shadow(0 4px 8px rgba(0, 0, 0, 0.15))",
            },
          }}
        />
      </Box>
    );
  }

  // Future: Support for iconify icons
  if (iconName) {
    return (
      <Box sx={defaultStyles}>
        {/* Future implementation for iconify icons */}
        <span>Icon: {iconName}</span>
      </Box>
    );
  }

  // Fallback placeholder
  return (
    <Box
      sx={{
        ...defaultStyles,
        backgroundColor: "#f5f5f5",
        border: "2px dashed #ddd",
        color: "#999",
        fontSize: "12px",
        textAlign: "center",
      }}
    >
      Icon
    </Box>
  );
};

ServiceIcon.displayName = "ServiceIcon";

export default ServiceIcon;
